if (document.getElementById('locations')) {
  import(/* webpackChunkName: "locations-chunk" */ '../../vue/entry/locations')
    .then(() => {
      console.log('%c%s', 'color: #78F27B;', '[VUE] Locations chunk loaded')
    })
    .catch((err) => {
      console.error(err)
    })
}
